import { combineReducers } from 'redux'
import emailLogs from 'reducers/lookUp/emailLogs'
import lookUpBatchLabels from './lookUpBatchLabels'

const lookUp = combineReducers({
  emailLogs,
  lookUpBatchLabels,
})

export default lookUp
